// Get Attachment by ID
export const ATTACHMENT_GET_BY_ID_REQUEST = 'ATTACHMENT_GET_BY_ID_REQUEST'
export const ATTACHMENT_GET_BY_ID_SUCCESS = 'ATTACHMENT_GET_BY_ID_SUCCESS'
export const ATTACHMENT_GET_BY_ID_FAIL = 'ATTACHMENT_GET_BY_ID_FAIL'

// List Internal Documents
export const ATTACHMENT_LIST_DOCUMENTS_REQUEST = 'ATTACHMENT_LIST_DOCUMENTS_REQUEST'
export const ATTACHMENT_LIST_DOCUMENTS_SUCCESS = 'ATTACHMENT_LIST_DOCUMENTS_SUCCESS'
export const ATTACHMENT_LIST_DOCUMENTS_FAIL = 'ATTACHMENT_LIST_DOCUMENTS_FAIL'

// Upload Internal Documents
export const ATTACHMENT_UPLOAD_DOCUMENTS_REQUEST = 'ATTACHMENT_UPLOAD_DOCUMENTS_REQUEST'
export const ATTACHMENT_UPLOAD_DOCUMENTS_SUCCESS = 'ATTACHMENT_UPLOAD_DOCUMENTS_SUCCESS'
export const ATTACHMENT_UPLOAD_DOCUMENTS_FAIL = 'ATTACHMENT_UPLOAD_DOCUMENTS_FAIL'

// Generate SAS URLs
export const ATTACHMENT_GENERATE_SAS_URLS_REQUEST = 'ATTACHMENT_GENERATE_SAS_URLS_REQUEST'
export const ATTACHMENT_GENERATE_SAS_URLS_SUCCESS = 'ATTACHMENT_GENERATE_SAS_URLS_SUCCESS'
export const ATTACHMENT_GENERATE_SAS_URLS_FAIL = 'ATTACHMENT_GENERATE_SAS_URLS_FAIL'

// Delete Internal Document
export const ATTACHMENT_DELETE_DOCUMENT_REQUEST = 'ATTACHMENT_DELETE_DOCUMENT_REQUEST'
export const ATTACHMENT_DELETE_DOCUMENT_SUCCESS = 'ATTACHMENT_DELETE_DOCUMENT_SUCCESS'
export const ATTACHMENT_DELETE_DOCUMENT_FAIL = 'ATTACHMENT_DELETE_DOCUMENT_FAIL'

// Reset state
export const ATTACHMENT_RESET = 'ATTACHMENT_RESET'
